import { IsUUID } from 'class-validator';

/** Aggiunge un lotto a un caso OPEN: bloccato subito con matchReason MANUAL. */
export class AddRecallCaseLotDto {
  @IsUUID()
  lotId!: string;
}
